import { RestUrl } from "../common/cyan.types";

export class AuthTokenUrl {
  public static createAuthToken: RestUrl = ["POST", "/tokens"];
  public static awakeAuthToken: RestUrl = ["POST", "/tokens/heartbeat"];
  public static refreshAuthToken: RestUrl = ["POST", "/token/refresh"];
  public static deleteAuthToken: RestUrl = ["DELETE", "/tokens"];
}
